import { useMemo } from 'react';
import { useFilteredStores } from './store';

export const useIsMixedCurrency = () => {
    const [filteredStores] = useFilteredStores();

    return useMemo(() => {
        if (!filteredStores) return false;
        return filteredStores.some((store) => store.forcedCurrency !== filteredStores[0].forcedCurrency);
    }, [filteredStores]);
};
